<template>
  <div class="help" v-if="this.$route.name == 'contentWeb'">
    <p class="title">Was this answer helpful?</p>
    <div>
      <span class="btn" @click="evaluation()" :class="{ active: this.active == 'yes' }">Yes</span>

      <span class="btn" @click="no()" :class="{ active: this.active == 'no' }">No</span>
    </div>
    <p class="undertxt">
      {{ this.liked }} out of
      {{ this.liked + this.disliked }}
      found this helpful
    </p>
  </div>
  <div class="help" v-if="this.$route.name == 'contentWebZh'">
    <p class="title">本文对您有帮助吗?</p>
    <div>
      <span class="btn" @click="evaluation()" :class="{ active: this.active == 'yes' }">是</span>

      <span class="btn" @click="no()" :class="{ active: this.active == 'no' }">否</span>
    </div>
    <p class="undertxt">
      {{ this.liked + this.disliked }}
      人中有 {{ this.liked }} 人觉得有帮助
    </p>
  </div>
</template>

<script>
export default {
  name: "Help",
  props: ["like", "dislike", "title"],
  data() {
    return {
      active: "",
      liked: "",
      disliked: "",
      change: false,
    };
  },
  mounted() {
    this.active = window.localStorage.getItem(this.title);
    console.log(this.$route);
    this.liked = this.like;
    this.disliked = this.dislike;
  },
  methods: {
    no() {
      if (this.active == null) {
        this.disliked = this.disliked + 1;
        window.localStorage.setItem(this.title, "no");
        this.update();
        axios({
          url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
          method: "POST",
          data: {
            methods: "negative",
            title: this.title,
          },
        }).then((res) => { 
          console.log(res);
        });
      } else if (this.active == "yes") {
        this.change = true;
        this.disliked = this.disliked + 1;
        this.liked = this.liked - 1;
        window.localStorage.setItem(this.title, "no");
        this.update();
        axios({
          url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
          method: "POST",
          data: {
            methods: "evaluation",
            title: this.title,
            todo: "Reduction",
          },
        }).then((res) => { console.log(res); });
      }
    },
    evaluation() {
      if (this.active == null) {
        window.localStorage.setItem(this.title, "yes");
        this.liked = this.liked + 1;
        this.update();
        axios({
          url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
          method: "POST",
          data: {
            methods: "evaluation",
            title: this.title,
          },
        }).then((res) => {
          this.update();
        });
      } else if (this.active == "no") {
        this.change = true;
        window.localStorage.setItem(this.title, "yes");
        this.liked = this.liked + 1;
        this.disliked = this.disliked - 1;
        this.update();

        axios({
          url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
          method: "POST",
          data: {
            methods: "negative",
            title: this.title,
            todo: "Reduction",
          },
        }).then((res) => {
          this.update();
        });
      }
    },
    update() {
      this.active = window.localStorage.getItem(this.title);
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  margin-top: 25px;
  padding-top: 25px;
  border-top: 1px solid #dddc;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;

  .undertxt {
    font-size: 14px;
  }

  .title {
    color: #222224;
    font-family: Nunito Regular, PingFangSC, Microsoft YaHei, sans-serif;
  }

  p {
    color: #7d7c80;
    margin-bottom: 10px;
  }

  div {
    display: flex;

    .btn {
      margin-right: 15px;
      margin-bottom: 10px;
      display: block;
      border: 2px solid rgba($color: #222224, $alpha: 1);
      border-radius: 30px;
      padding: 3px 6px;
      width: 75px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba($color: #222224, $alpha: 1);
        color: #fff;
      }

      &.active {
        background-color: rgba($color: #222224, $alpha: 1);
        color: #fff;
      }
    }

    .count {
      margin-right: 15px;
      text-align: center;
      padding: 5px;
    }
  }
}
</style>
